import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	updateJiraButtonText: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-button-text',
		defaultMessage: 'Review changes',
		description:
			'The label for the button that is used to show a dialog of all the changes that can be committed to Jira',
	},
	updateJiraButtonGeneralTooltip: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-button-general-tooltip',
		defaultMessage: 'Review changes',
		description:
			'Tooltip label for the button which opens dialog of all changes to be committed to Jira',
	},
	updateJiraButtonTooltip: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-button-tooltip',
		defaultMessage: 'No changes have been made in this plan',
		description: 'It is a tooltip message for the disabled updateJira button',
	},
	updateJiraDialogHeader: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-header',
		defaultMessage: 'Review changes',
		description: 'This is the title of the dialog used to commit changes to Jira',
	},
	updateJiraDialogContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-content',
		defaultMessage:
			"These changes are only saved in your plan. To see these changes in Jira, you'll need to save these in Jira first.",
		description: 'This is the sub-title of the dialog used to commit changes to Jira',
	},
	updateJiraDialogRevertButtonText: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-revert-button-text',
		defaultMessage: 'Discard selected changes',
		description:
			'This is label for the button to revert changes to be the same as currently on Jira',
	},
	updateJiraDialogUpdateButtonText: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-update-button-text',
		defaultMessage: 'Save selected changes in Jira',
		description: 'This is the label on the button used to commit changes to Jira',
	},
	updateJiraDialogStopButtonText: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-stop-button-text',
		defaultMessage: 'Quit',
		description:
			'The label on a button that can be used to prevent further changes from being committed to Jira.',
	},
	updateJiraDialogStoppingButtonText: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-stopping-button-text',
		defaultMessage: 'Quitting',
		description:
			'The label on a button indicating that the user has requested that further changes should not be committed, but that the last change is already in the process of being committed.',
	},
	outOfSyncMessageConcurrentEditing: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.out-of-sync-message-concurrent-editing',
		defaultMessage: 'Your plan is out of sync due to concurrent editing.',
		description: 'Message shown when plan is out of sync due to concurrent editing',
	},
	refreshCta: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.refresh-cta',
		defaultMessage:
			'<span>Refresh</span> to get the latest version. Your changes will not be lost.',
		description: 'Message shown when plan is out of sync due to concurrent editing',
	},
	disabledTooltipForUpdateJira: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.disabled-tooltip-for-update-jira',
		defaultMessage: "You don't have permission to save changes in Jira.",
		description: 'Tooltip shown when update/connect jira is disabled',
	},
	disabledTooltipForUpdateJiraWhenGicIsOpen: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.disabled-tooltip-for-update-jira-when-gic-is-open',
		defaultMessage:
			"You can't save selected changes in Jira because you already have an issue in creation.",
		description:
			'Tooltip shown when update/connect jira is disabled because there is an existing issue create modal opened',
	},
});

export default messages;
